import { text } from './text';

const palette = {
  50: '#e1f8fc',
  100: '#b3edf7',
  200: '#82e1f2',
  300: '#4ed5eb',
  400: '#26cbe5',
  500: '#00c2e0',
  600: '#00a6c5',
  700: '#0096ad',
  800: '#007797',
  900: '#005173',
  contrastText: text.contrast,
};

export const blue = {
  ...palette,
  light: palette[300],
  main: palette[600],
  dark: palette[800],
  darker: palette[900],
  contrastText: text.contrast,
};
